import React from 'react'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import { Box } from '@mui/material'
import CloseIcon from '../../../../Assets/Images/Login/no.svg'

export default function ContentProductNegativeMargin({ setCloseWarningModal }) {
  const handleCloseWarningModal = () => {
    setCloseWarningModal(false)
  }

  return (
    <Box
      className="modal-box-message"
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <img
        src={CloseIcon}
        alt="close"
        onClick={handleCloseWarningModal}
        style={{
          position: 'absolute',
          top: '25px',
          right: '30px',
          cursor: 'pointer',
        }}
      />
      <ExclamationTriangleFill
        style={{
          fontSize: '40px',
          color: '#FF2A40',
          marginBottom: '19px',
        }}
      />
      <p
        style={{
          textAlign: 'center',
          fontSize: '20px',
          fontWeight: 'semibold',
        }}>
        La orden de venta requiere aprobación. <br />
        Los precios otorgados, deben ser mayor al costo del producto.
      </p>
    </Box>
  )
}
